import classNames from "classnames";
import { ReactNode } from "react";

const Section = ({
  children,
  light,
}: {
  children: ReactNode;
  light?: boolean;
}) => {
  return (
    <section
      className={classNames([
        "p-6 lg:py-10 xl:py-14",
        light ? "bg-primary text-secondary-main" : "",
      ])}
    >
      <div className="mx-auto w-full max-w-[1440px]">{children}</div>
    </section>
  );
};

export default Section;
